import SEO from "../components/SEO/SEO";
import Header from "../components/Header/Header";
import Hero from "../components/Hero/Hero";
import Services from "../components/Services/Services";
import Showcase from "../components/Showcase/Showcase";
import About from "../components/About/About";
import Gallery from "../components/Gallery/Gallery";
import Contact from "../components/Contact/Contact";
import Footer from "../components/Footer/Footer";
import WhatsAppButton from "../components/WhatsApp/WhatsAppButton";

const HomePage = () => {
  return (
    <>
      <SEO
        title="Baby Zoo Garden - Art&Fun Club | Kreativne radionice Zagreb"
        description="Profesionalne kreativne radionice, facepainting i animacije za djecu u Zagrebu. Slikanje, art terapija i nezaboravne proslave. ☎ 099 315 2678"
        keywords="kreativne radionice djeca Zagreb, facepainting Zagreb, slikanje djeca, art terapija, animacije rođendani, Baby Zoo Garden, Marina Bogdanić"
        url="https://babyzoogarden.com"
      />

      {/* Header - landmark: banner */}
      <Header />

      {/* Main content - landmark: main */}
      <main id="main-content" role="main">
        <Hero />
        <Services />
        <Showcase />
        <About />
        <Gallery />
        <Contact />
      </main>

      {/* Footer - landmark: contentinfo */}
      <Footer />

      {/* WhatsApp floating button */}
      <WhatsAppButton />
    </>
  );
};

export default HomePage;
